import { StringKey } from '../../../lang/index';
import {
  AdminNotificationTag,
  adminNotificationTagMap,
  NotificationTag,
  notificationTagMap,
} from '../../../types/user.types';

export enum NotificationTableColumn {
  EMAIL = 'email',
  IMPORTANCE = 'importance',
  IN_APP = 'in-app',
  NOTIFICATION_DESCRIPTION = 'notification-description',
  NOTIFICATION_TYPE = 'notification-type',
}

export const notificationTableColumnMap = Object.values(NotificationTableColumn);

export const notificationTableColumnTitle: Record<NotificationTableColumn, StringKey> = {
  [NotificationTableColumn.EMAIL]: 'EMAIL',
  [NotificationTableColumn.IMPORTANCE]: 'IMPORTANCE',
  [NotificationTableColumn.IN_APP]: 'IN_APP',
  [NotificationTableColumn.NOTIFICATION_DESCRIPTION]: 'NOTIFICATION_DESCRIPTION',
  [NotificationTableColumn.NOTIFICATION_TYPE]: 'NOTIFICATION_TYPE',
};

export const notificationTableColumnTitleMap = Object.entries(notificationTableColumnTitle);

export enum NotificationSettingTab {
  ADMIN = 'admin',
  STAKEHOLDER = 'stakeholder',
}

export const notificationSettingTabTitle: Record<NotificationSettingTab, StringKey> = {
  [NotificationSettingTab.ADMIN]: 'ADMIN',
  [NotificationSettingTab.STAKEHOLDER]: 'STAKEHOLDER',
};

export const notificationTabTags: Record<
  NotificationSettingTab,
  (AdminNotificationTag | NotificationTag)[]
> = {
  [NotificationSettingTab.ADMIN]: adminNotificationTagMap,
  [NotificationSettingTab.STAKEHOLDER]: notificationTagMap,
};

export const notificationSettingTabTitleMap = Object.entries(notificationSettingTabTitle);
